fragment AppCtaFragment on appCta_Entry {
  typeHandle
}
